<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-list"></i>
          <strong>
            {{title}}
            <b-spinner v-if="loading" class="float-right" small/>
          </strong>
        </div>
        <div>
          <stock-list :column_display="column_display"
                      :columns="columns"
                      :filterable="filterable"
                      :headings="headings"
                      :url="url"
                      @on-loading="loading=$event"/>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
  import StockList from '../ServerFilterableTable'

  export default {
    name: "AreaStock",
    components: {
      StockList
    },
    data () {
      return {
        title: "Listado de stock",
        loading: false,
        column_display: {
            product_family: 'not_desktop',
            product_fruit: 'not_desktop',
            'product_type.name': "not_desktop",
            lot: '',
            product_code: '',
            product: '',
            number: '',
            quantity: '',
            container: '',
            creation_date: 'not_desktop',
            net_kilograms: '',
            gross_kilograms: '',
            position: 'not_desktop',
          },
        columns: [
          "stock_area__name",
          "product__fruit__family__name",
          "product__fruit__name",
          "product__code",
          "product__name",
          "net_kilograms",
        ],
        filterable: [
          "stock_area__name",
          "product__fruit__family__name",
          "product__fruit__name",
          "product__name",
          "product__code",
        ],
        headings: {
          stock_area__name: "Area",
          product__fruit__family__name: "Familia",
          product__fruit__name: "Fruta",
          product__code: "Código",
          product__name: "Producto",
          quantity: "Cantidad",
          net_kilograms: "KN",
        },
        // listColumns: {
        //   document_type: [
        //     {id: 0, text: 'Guia de despacho'},
        //     {id: 1, text: 'Factura'},
        //     {id: 2, text: 'Otro'},
        //   ]
        // },
      }
    },
    computed:{
      stock_area_filter_constructor() {
        let filter = this.$route.params;
        filter = !_.isEmpty(filter) ? filter.process_type_complete.stockarea_set.map(e => e.id).join("|stock_area=") : "";
        return 'stock_area='+filter;
      },
      url() {
        return '/bagno/area-stock/?'
      }
    },
    methods: {
      rowClassCallback() {
        return 'table-warning'
      },
    }
  }
</script>

<style scoped>

</style>
